/**
 * Route-level loading fallback.
 *
 * Rendered by the <Suspense> boundary in App.tsx while a lazily imported page
 * chunk is fetched. Deliberately dependency-free: it ships in the eager shell,
 * so anything it imported would re-inflate the initial bundle.
 */
export function RouteFallback() {
  return (
    <div
      className="min-h-[50vh] flex items-center justify-center"
      role="status"
      aria-live="polite"
      data-testid="route-fallback"
    >
      <div
        className="h-8 w-8 rounded-full border-2 border-oc-emerald border-t-transparent animate-spin"
        aria-hidden="true"
      />
      <span className="sr-only">Loading…</span>
    </div>
  )
}
